import {redirect} from '@github-ui/react-router'
import type {LoaderFunctionArgs} from '@github-ui/react-router'
import {ssrSafeLocation} from '@github-ui/ssr-utils'

/**
 * Redirects from the legacy /:owner/:repo/issues/labels path
 * to the /:owner/:repo/labels (with search params)
 * Note: URL hash (#something) is not available in loaders (it's client-only and never sent to the server)
 */
export function labelsLegacyRedirectLoader({params, request}: LoaderFunctionArgs) {
  const {owner, repo} = params
  const url = new URL(request.url, ssrSafeLocation.origin)
  return redirect(`/${owner}/${repo}/labels${url.search}`)
}
